<template>
  <div>
      <div v-if="loading">
        <loader></loader>
      </div>
      <div class="form">
        <div class="alert alert-danger" v-if="errorMessage">
          {{errorMessage}}
        </div>
        <div class="alert alert-success" v-if="success">
          Cadastro realizado com sucesso. 
          <router-link to="/login">Clique aqui para realizar o login</router-link>
        </div>
        <fieldset>
          <legend>Meus Dados</legend>
          <div class="form-group">
            <label for="name">Nome Completo <span class="required">*</span></label>
            <input id="name" class="form-control" type="text" v-model="user.name">
          </div>
          <div class="form-group">
            <label for="email">Email <span class="required">*</span> (de preferência o institucional)</label>
            <input id="email" class="form-control" type="email" v-model="user.email" placeholder="Ex: maria@barreiros.ifpe.edu.br">
          </div>
          <div class="form-group">
            <label for="email">Confirmar Email <span class="required">*</span> </label>
            <input id="emailConf" class="form-control" type="email" v-model="confirmEmail">
          </div>          
          <div class="form-group">
            <label for="password">Senha <span class="required">*</span></label>
            <input id="password" class="form-control" type="password" v-model="user.password">
          </div>
          <div class="form-group">
            <label for="password">Confirmar Senha <span class="required">*</span></label>
            <input id="passwordConf" class="form-control" type="password" v-model="confirmPassword">
          </div>
        </fieldset>
        <button class="btn btn-primary" @click="signup">Cadastrar</button>
        <button class="btn btn-default" @click="$router.go(-1)">Voltar</button>
      </div>
  </div>
</template>

<script>

import { Parse } from '../Global'
import Loader from './util/Loader'

export default {
  components: {
    Loader
  },
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: ''
      },
      confirmPassword: '',
      confirmEmail: '',
      errorMessage: '',
      loading: false,
      success: false
    }
  },
  mounted () {
    this.loading = false
    this.success = false
  },
  methods: {
    signup () {
      self.success = false
      self.errorMessage = null
      if ((this.user.password !== this.confirmPassword) || (this.user.email !== this.confirmEmail)) {
        this.errorMessage = 'Os campos de email e senha devem ser iguais.'
      } else {
        let self = this
        self.loading = true
        Parse.Cloud.run('signUp', this.user).then((token) => {
          Parse.User.become(token)
          self.success = true
          self.loading = false
          self.errorMessage = null
        }, (error) => {
          console.log(error)
          self.errorMessage = 'Ocorreu um erro durante cadastro: ' + error.message
          self.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>
.form {
  max-width: 500px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Signup.vue?05ae72bb